import { useContext } from 'react';
import isMobile from 'ismobilejs';
import type { Chat } from '@trinity/chat';
import { useAvatarPanel } from '@trinity/chat-components/components/DigitalTwin/AvatarPanel.context';
import { IsSidePanelMessageContext } from './context';
import { SystemAuthor } from './Message.Author';
import { useStyles } from './Message.System.styles';
import { ChatMessageVariantSelector } from './Message.VariantSelector';

type Props = {
  className?: string;
  item: Chat.Query;
};

export const SystemUserCancelledMessage = ({ className, item }: Props) => {
  const device = isMobile();
  const isSidePanel = useContext(IsSidePanelMessageContext);
  const styles = useStyles(isSidePanel);
  const { showAuthor } = useAvatarPanel();

  return (
    <div css={styles.root} className={className}>
      {showAuthor && !device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor css={styles.author} />
          <ChatMessageVariantSelector item={item} />
        </div>
      )}
      <div>
        <div css={[styles.body, { fontStyle: 'italic' }]}>Message cancelled by user.</div>
      </div>
    </div>
  );
};
